var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 17.5,
    height: 17.5,
    rx: 2,
    fill: "#0D0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9392 10.2902L16.5926 5H15.4899L11.4493 9.59339L8.22217 5H4.5L9.38013 11.946L4.5 17.4936H5.60277L9.8697 12.6428L13.2778 17.4936H17L11.9389 10.2902H11.9392ZM10.4288 12.0072L9.93434 11.3155L6.00011 5.81188H7.69391L10.8689 10.2535L11.3633 10.9452L15.4904 16.7186H13.7966L10.4288 12.0075V12.0072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5abccc2fd783bd5118f0d9251497f7db.svg";
export { ForwardRef as ReactComponent };